"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const getLinearDistance_1 = __importDefault(require("../../shared/getLinearDistance"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../shared/getValueByPathFromUnknown"));
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const appStateSelectBOGoogleApiKey_1 = __importDefault(require("../../shared/appStateSelectBOGoogleApiKey"));
const buildCallableGetDistance = (args) => async ({ functionId, entryVars: { mode, latitudeDestination: entryLatitudeDestination, latitudeOrigin: entryLatitudeOrigin, longitudeDestination: entryLongitudeDestination, longitudeOrigin: entryLongitudeOrigin, }, callbacks, executeProcesses, store, }) => {
    const aceptedModes = ['linear', 'route'];
    const onError = (message) => executeProcesses(functionId, callbacks.error, message);
    if (!(0, ts_validators_1.valueIsString)(mode) || !aceptedModes.includes(mode)) {
        onError(`Invalid mode to calculate distance: ${mode}`);
        return;
    }
    let latitudeDestination;
    try {
        latitudeDestination = (0, getNumberFromUnknown_1.default)(entryLatitudeDestination);
    }
    catch (_a) {
        onError(`Destination latitude should be a number: [${entryLatitudeDestination}]`);
        return;
    }
    let latitudeOrigin;
    try {
        latitudeOrigin = (0, getNumberFromUnknown_1.default)(entryLatitudeOrigin);
    }
    catch (_b) {
        onError(`Origin latitude should be a number: [${entryLatitudeOrigin}]`);
        return;
    }
    let longitudeDestination;
    try {
        longitudeDestination = (0, getNumberFromUnknown_1.default)(entryLongitudeDestination);
    }
    catch (_c) {
        onError(`Origin latitude should be a number: [${entryLongitudeDestination}]`);
        return;
    }
    let longitudeOrigin;
    try {
        longitudeOrigin = (0, getNumberFromUnknown_1.default)(entryLongitudeOrigin);
    }
    catch (_d) {
        onError(`Origin latitude should be a number: [${entryLongitudeOrigin}]`);
        return;
    }
    if (mode === 'linear') {
        const kilometers = (0, getLinearDistance_1.default)({
            latitudeDestination,
            latitudeOrigin,
            longitudeDestination,
            longitudeOrigin,
            unit: 'K',
        });
        executeProcesses(functionId, callbacks.success, { meters: (kilometers / 0.0010000).toFixed(1), kilometers });
        return;
    }
    const googleApiKey = (0, appStateSelectBOGoogleApiKey_1.default)(store.getState());
    if (!googleApiKey) {
        onError('To use this function you need to set a google API key. You can add it in: App dashboard/Settings/App keys/Google API. After add it, reload your app.');
        return;
    }
    try {
        const distance = await args.getGoogleDistanceMatrix({
            googleApiKey,
            origin: {
                latitude: latitudeOrigin,
                longitude: longitudeOrigin,
            },
            destination: {
                latitude: latitudeDestination,
                longitude: longitudeDestination,
            },
        });
        executeProcesses(functionId, callbacks.success, distance);
    }
    catch (error) {
        const errorMessage = (0, getValueByPathFromUnknown_1.default)(error, ['message']);
        onError(`${errorMessage}`);
    }
};
exports.default = buildCallableGetDistance;
